<template>
  <svg
    v-if="icon === 'push-status-created'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 18.3281C8.51255 18.3281 5.67188 15.4875 5.67188 12C5.67188 8.51255 8.51255 5.67188 12 5.67188C15.4875 5.67188 18.3281 8.51255 18.3281 12C18.3281 15.4875 15.4875 18.3281 12 18.3281ZM14.7256 11.6978H12.6846V9.52246H11.417V11.6978H9.36523V12.8901H11.417V15.2158H12.6846V12.8901H14.7256V11.6978Z"
      :fill="color || '#277FAF'"
    />
    <path
      d="M12 24C18.5953 24 24 18.5953 24 12H21.1875C21.1875 17.0344 17.0344 21.1406 12 21.1406C6.96558 21.1406 2.85938 17.0344 2.85938 12C2.85938 6.96558 6.96558 2.85938 12 2.85938C14.0532 2.85938 15.9516 3.53433 17.4703 4.6875L16.4016 5.75625L21.3656 6.74063L20.3813 1.77652L19.4813 2.67652C17.4281 1.03125 14.8266 0 12 0C5.40469 0 0 5.40469 0 12C0 18.5953 5.40469 24 12 24Z"
      :fill="color || '#277FAF'"
    />
  </svg>
  <svg
    v-else-if="icon === 'push-status-in_progress'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.67188 12C5.67188 15.4875 8.51255 18.3281 12 18.3281C15.4875 18.3281 18.3281 15.4875 18.3281 12C18.3281 8.51255 15.4875 5.67188 12 5.67188C8.51255 5.67188 5.67188 8.51255 5.67188 12ZM15.3046 11.0859L11.2969 15.1079L8.69536 12.4922L9.67969 11.5079L11.2969 13.1109L14.3204 10.1016L15.3046 11.0859Z"
      :fill="color || '#219653'"
    />
    <path
      d="M12 24C18.5953 24 24 18.5953 24 12H21.1875C21.1875 17.0344 17.0344 21.1406 12 21.1406C6.96558 21.1406 2.85938 17.0344 2.85938 12C2.85938 6.96558 6.96558 2.85938 12 2.85938C14.0532 2.85938 15.9516 3.53433 17.4703 4.6875L16.4016 5.75625L21.3656 6.74063L20.3813 1.77652L19.4813 2.67652C17.4281 1.03125 14.8266 0 12 0C5.40469 0 0 5.40469 0 12C0 18.5953 5.40469 24 12 24Z"
      :fill="color || '#219653'"
    />
  </svg>
  <svg
    v-else-if="icon === 'push-status-done'"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12C0 18.6132 5.38676 24 12 24C18.6132 24 24 18.6132 24 12C24 5.38676 18.6132 0 12 0C5.38676 0 0 5.38676 0 12ZM18.2666 10.2666L10.6667 17.8934L5.73342 12.9333L7.6 11.0668L10.6667 14.1066L16.4001 8.4L18.2666 10.2666Z"
      :fill="color || '#EB5757'"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsPushStatus',
  props: { icon: String, color: String, width: [Number, String], height: [Number, String] },
}
</script>

<style scoped></style>
